export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives13.cbbc9ae4.jpg";